/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  },2000);
}

// Prevent stale cart JSON responses (some browsers/CDNs can cache /cart.js).
// This also ensures the offcanvas mini cart (offcanvas-cart-content-container) updates immediately after AJAX adds.
if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function' && !Shopify.__noCacheGetCartInstalled) {
  Shopify.__noCacheGetCartInstalled = true;
  Shopify.__getCartOriginal = Shopify.getCart;
  Shopify.getCart = function(callback) {
    jQuery.getJSON('/cart.js?cb=' + Date.now(), function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      } else if (typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate(cart);
      }
    });
  };
}

// SWAQ Video Message (and any app that adds an extra line item after our add-to-cart)
// adds its product AFTER our AJAX add resolves, then fires these events when done.
// Our own success handler renders the mini cart too early to include it, so we
// re-render the offcanvas mini cart whenever one of these completion events fires.
if (typeof Shopify !== 'undefined' && !Shopify.__externalCartRefreshInstalled) {
  Shopify.__externalCartRefreshInstalled = true;
  var swaqRefreshTimer = null;
  var refreshMiniCartFromExternal = function () {
    // debounce: SWAQ fires several of these events in quick succession
    clearTimeout(swaqRefreshTimer);
    swaqRefreshTimer = setTimeout(function () {
      if (typeof Shopify.getCart === 'function') {
        Shopify.getCart(); // -> onCartUpdate -> cartUpdateInfo re-renders .single-cart-item-loop & .bigcounter
      }
    }, 150);
  };
  ['cart-update', 'ajaxCart.afterCartLoad', 'shopify:cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, refreshMiniCartFromExternal);
    window.addEventListener(evt, refreshMiniCartFromExternal);
  });
}

Shopify.addItem = function(variant_id, quantity, callback){
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        window.lastAddedProductId = line_item.product_id || line_item.id || variant_id;
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("data-srcset");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
   // var propPrice = jQuery('#product_current_price').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').html(title);  
    //jQuery('.pop_current_price').text('"'+ propPrice +'"');
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').html(title); 
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length) {
            jQuery(".single-product-cart, .item-multiple-item-count,.cart-product-wrapper").css({"display": "flex"});
            jQuery(".single-cart-product.empty , .item-single-item-count").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              // Mirror snippets/mini-cart.liquid so the AJAX-rendered mini cart matches
              // the Liquid-rendered one after a page refresh (product title + variant on
              // its own line, "X " separator, and theme money format without trailing zeros).
              var productTitle = item.product_title || item.title;
              var isSetupFee = (productTitle || '').indexOf('Set Up Fee') !== -1;

              var removeIcon = isSetupFee
                ? '<span class="cart-close-icon cart-close-icon--disabled"> <a href="javascript:void(0);" aria-label="This item cannot be removed"><i class="ti-close"></i></a> </span>'
                : '<span class="cart-close-icon"> <a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="ti-close"></i></a> </span>';

              var titleHtml = isSetupFee
                ? productTitle
                : '<a href="' + item.url + '">' + productTitle + '</a>';

              var variantHtml = (item.variant_title && item.variant_title.indexOf('Default') === -1)
                ? '<span class="product-variation">' + item.variant_title + '</span>'
                : '';

              jQuery('<div class="single-cart-product product-id-' + item.product_id + ' variant-id-' + item.variant_id + '" data-product-id="' + item.product_id + '" data-variant-id="' + item.variant_id + '">' + removeIcon + '<div class="image"> <a href="' + item.url + '"> <img src="' + item.image + '" class="img-fluid" role="presentation"> </a></div><div class="content">' + titleHtml + variantHtml + '<p><span class="cart-count">' + item.quantity + ' X </span> <span class="discounted-price">' + Shopify.moneyNoTrailingZeros(item.price) + '</span></p></div></div>').appendTo(table);
            });
          }
          else {
            jQuery(".single-product-cart, .item-single-item-count,.cart-product-wrapper").css({"display": "none"});
            jQuery(".single-cart-product.empty").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.moneyNoTrailingZeros(cart.total_price));
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};

// Format money like the Liquid `money_without_trailing_zeros` filter, using the theme's
// real money format (window.themeMoneyFormat, set in footer-js.liquid) so AJAX-rendered
// prices match the Liquid-rendered cart exactly (e.g. "$ 30" and "$ 1.99").
Shopify.moneyNoTrailingZeros = function (cents) {
  var format = window.themeMoneyFormat || Shopify.money_format || "${{amount}}";
  var formatted = Shopify.formatMoney(cents, format);
  // Drop the decimal part only when the amount is a whole number (".00" at the end).
  return formatted.replace(/([.,])0+$/, '');
};
